import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import TopHeader from './TopHeader/TopHeader';
import HeaderMenu from './HeaderMenu/HeaderMenu';
import CheckoutHeader from './CheckoutHeader/CheckoutHeader';
import AddedToCart from './AddedToCart/AddedToCart';
import { optimonkSetCart, setAttribute } from '../lib/optimonk';
import { login, loginFacebook, createUser } from '../../../redux/modules/user';
import { saveSourceMedium } from '../../../redux/modules/checkout';
import { primary_s26_l96 } from '../../shared/lib/colors';
import { isArrayEqual } from '../../../utils/arrays';
import { round2Decimals } from '../../../utils/numbers';

import './Header.scss';

class Header extends Component {
  componentDidMount() {
    this._getMediumSource();
  }

  componentDidUpdate(prevProps) {
    if (
      (!isArrayEqual(prevProps.cart, this.props.cart) &&
        !!prevProps.cart.length &&
        !!this.props.cart.length) ||
      prevProps.cart.length !== this.props.cart.length
    ) {
      setAttribute(
        'cart',
        round2Decimals(
          this.props.cart.reduce(
            (acc, item) => acc + item.price * item.quantity,
            0
          )
        )
      );
      optimonkSetCart(this.props.cart);
    }
    if (prevProps.user.id !== this.props.user.id) {
      if (!!this.props.user.id) {
        setAttribute('guest', false);
      } else {
        setAttribute('guest', true);
      }
    }
  }

  _getMediumSource = () => {
    if (typeof window !== 'undefined') {
      let medium = sessionStorage.getItem('medium');
      let source = sessionStorage.getItem('source');
      if ((!medium || !source) && !!window.visitData) {
        const visitData = window.visitData.get();
        medium = visitData.medium;
        source = visitData.source;
        if (!!medium && !!source) {
          sessionStorage.setItem('medium', medium);
          sessionStorage.setItem('source', source);
        }
      }
      this.props.saveSourceMedium({ medium, source });
    }
  };

  renderBackgroundVersion = uiVariantBackground => {
    switch (uiVariantBackground) {
      case '1':
        return primary_s26_l96(this.props.primaryColor);
      case '2':
        return '#f6f6f6';
      case '3':
        return '#fff';
      // default:
      //   return primary_s26_l96(this.props.primaryColor);
      default:
        return uiVariantBackground;
    }
  };

  render() {
    const {
      isCheckout,
      login,
      user,
      isAuthenticated,
      phone,
      phone2,
      primaryColor,
      secondaryColor,
      headerMenuOpen,
      loginFacebook,
      createUser,
      checkout,
    } = this.props;

    return (
      <header
        className={`${isCheckout ? 'header-checkout' : 'header-not-checkout'} ${
          headerMenuOpen ? 'menu-open' : 'menu-closed'
        }`}
        style={{
          backgroundColor: this.renderBackgroundVersion(
            this.props.uiVariantBackground
          ),
          overflow: 'visible',
        }}
      >
        <TopHeader
          isCheckout={isCheckout}
          user={user}
          isAuthenticated={isAuthenticated}
          onLogin={login}
          onLoginFacebook={loginFacebook}
          createUser={createUser}
          phone={phone}
          phone2={phone2}
          primaryColor={primaryColor}
        />

        {isCheckout ? (
          <CheckoutHeader />
        ) : (
          <HeaderMenu
            user={user}
            isAuthenticated={isAuthenticated}
            onLogin={login}
            phone={phone}
            phone2={phone2}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            onLoginFacebook={loginFacebook}
            createUser={createUser}
          />
        )}

        <AddedToCart />
      </header>
    );
  }
}

const mapStateToProps = state => ({
  storeData: state.store.data,
  checkout: state.checkout,
  user: state.user.data,
  cart: state.cart,
  isAuthenticated: state.user.authenticated,
  phone: state.store.data.datiFarmacia.phone,
  phone2: state.store.data.datiFarmacia.phone2,
  primaryColor: state.store.data.loghiTemplate.brandColor,
  secondaryColor: state.store.data.loghiTemplate.secondaryColor,
  headerMenuOpen: state.showHeaderMenu.headerMenuOpen,
  uiVariantBackground: state.store.data.uiVariants.background,
  hasCriteo: state.store.data.features.hasCriteo,
  criteoAccountId: state.store.data.integrazioni.criteo.accountId,
  hasOptimonk: state.store.data.features.hasOptimonk,
  optimonkAccountId: state.store.data.integrazioni.optimonk.accountId,
  hasIubendaCookieSolution: state.store.data.features.hasIubendaCookieSolution,
  checkout: state.checkout,
});

export default withRouter(
  connect(mapStateToProps, {
    login,
    loginFacebook,
    createUser,
    saveSourceMedium,
  })(Header)
);
